import { useEffect, useState } from "react";

// Hooks
import { useAddToHomescreenPrompt } from "@utility/hooks/useAddToHomescreenPrompt";

// Component
import { Grid, Container } from "@mui/material";
import ImageShow from "views/components/ImageShow";

export default function NotificationSubscriptionMobile({
  notificationStatus,
  configInstallPWA,
  setNotificationStatusMobile,
}) {
  const [isAppInstalled, setIsAppInstalled] = useState(false);
  const [prompt, promptToInstall] = useAddToHomescreenPrompt();
  // const applicationServerKeyData = 'BIVW5jjodYeBNcX5fO1S9CinSgldVY0JTbFRCyZ_auqrxL2BJOXlXiSE8nEdRk2BiCneGHMTwSqe3cAN5LlEXs4';
  let initializedEvent = false;
    
  const handleSubscribeClick = async () => {
    promptToInstall();
    setNotificationStatusMobile(true);
    setIsAppInstalled(true);
  };

  const handleCancelClick = () => {
    setNotificationStatusMobile(true);
    setIsAppInstalled(true);
  };

  const isPWAInstalled = async () => {
    try {
      const relatedApps = await navigator.getInstalledRelatedApps();
      const installed = relatedApps.find(
        (app) => app.url === configInstallPWA.data.url
      );
      if (installed !== undefined) {
        setIsAppInstalled(true);
        setNotificationStatusMobile(true);
      } else {
        setIsAppInstalled(false);
      }
    } catch (error) {
      setIsAppInstalled(true);
      setNotificationStatusMobile(true);
    }
  };

  useEffect(() => {
    // ดัก Event ให้ทำงานก่อนเขียน Component
    if (!initializedEvent) {
      initializedEvent = true;

      // ตรวจสอบบราวเซอร์รองรับการติดตั้งแอพที่หน้าจอโฮม
      if ("getInstalledRelatedApps" in window.navigator) {
        if (prompt === null) {
          isPWAInstalled(prompt);
        }
      } else {
        setNotificationStatusMobile(true);
        setIsAppInstalled(true);
      }
    }
  }, [prompt]);

  return (
    prompt !== null &&
    !isAppInstalled &&
    !notificationStatus && (
      <Container maxWidth="lg" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
        <div className="pwaPopupInstallAppMobie">
          <div className="positionFixed topLeft leftCenter traslateXCenter zIndexLarge zIndexMax contentWidth">
            <div className="pwaPopupInstallApp displayInlineBlock">
              <Grid container alignItems="center">
                <Grid item xs={1}>
                <ImageShow className="pwaIconSize" src={configInstallPWA?.icon} alt="ติดต่อพนักงาน สล็อตออนไลน์" />
                </Grid>
                <Grid item xs={8}>
                  <div className="pwaIconTitle pwaTitle textBoldMedium">
                    {configInstallPWA?.text}
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <button
                    className="btn btnPWAInstall btnHover btnWidthFull btnRadiusLow"
                    onClick={handleSubscribeClick}
                  >
                    <div className="center pwaIconTitle textBoldMedium">
                      ติดตั้ง
                    </div>
                  </button>
                </Grid>
                <Grid item xs={1} style={{ paddingLeft: '3px' }}>
                  <img
                    className="btn btnPWACancel btnHover btnWidthFull btnRadiusLow"
                    src="/images/icon/cancel.svg"
                    alt="close"
                    onClick={handleCancelClick}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
        </div>
      </Container>
      
    )
  );
}
